import { useEffect, useState } from 'react';

import { onFlash } from './sightFlash';

/** Четыре знака на 800 мс. Кнопки ноги не перекрывает, буфер не трогает. */
export function SightFlash(): React.ReactElement | null {
  const [code, setCode] = useState<string | null>(null);
  useEffect(() => onFlash(setCode), []);
  if (code === null) return null;
  return (
    <div className="nx-sight" role="status" aria-live="polite">
      {code}
    </div>
  );
}
